(function () {
  "use strict";

  var VISIBILITY_THRESHOLD = 0.3;
  var SECTION_SELECTOR = ".wb-purity";
  var AUTOPLAY_SELECTOR = "[data-wb-autoplay]";
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initSection(section) {
    if (!section || section.__wbPurityInit) return;

    var wrappers = Array.prototype.slice.call(section.querySelectorAll(AUTOPLAY_SELECTOR));
    var observers = [];

    if (!wrappers.length) return;

    section.__wbPurityInit = true;

    wrappers.forEach(function (wrapper) {
      var video = wrapper.querySelector("video");
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      if (prefersReducedMotion) {
        video.preload = "metadata";
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: VISIBILITY_THRESHOLD });

      observer.observe(wrapper);
      observers.push(observer);
    });

    section.__wbPurityCleanup = function () {
      observers.forEach(function (observer) {
        observer.disconnect();
      });

      wrappers.forEach(function (wrapper) {
        var video = wrapper.querySelector("video");
        if (video) video.pause();
      });

      section.__wbPurityInit = false;
    };
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section) initSection(section);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section && section.__wbPurityCleanup) section.__wbPurityCleanup();
  });
})();